<template>
  <v-app class="landing-layout">
    <v-main class="landing-main">
      <slot />
    </v-main>

    <AppFooter />
  </v-app>
</template>


<script setup>
import AppFooter from "~/components/AppFooter.vue";
</script>

<style scoped>
.landing-layout,
.landing-main {
  min-height: 100vh;
}
</style>
